import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function ErrorView() {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.panel.body.errors.loading"
    })
  });
}
export default ErrorView;